import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { StorageService } from '@services';

/**
 * Bloquea las rutas de /academy si la compañía no tiene el módulo de perfil académico activo.
 * El permiso `permissions.academicProfileModule` llega via CompanyGuardCheck / CompanyResolver
 * del route padre `:slug` y queda disponible en storage.
 */
@Injectable({ providedIn: 'root' })
export class AcademyModuleGuard implements CanActivate {

    constructor(private router: Router, private storageService: StorageService) {}

    canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
        const company: any = this.storageService.get('company');

        if (company?.permissions?.academicProfileModule) {
            return true;
        }

        const slug = this.getSlug(route) || company?.slug;
        return slug
            ? this.router.createUrlTree(['/learn', slug])
            : this.router.createUrlTree(['/login']);
    }

    private getSlug(route: ActivatedRouteSnapshot): string | null {
        let snap: ActivatedRouteSnapshot | null = route;
        while (snap) {
            const slug = snap.paramMap.get('slug');
            if (slug) { return slug; }
            snap = snap.parent;
        }
        return null;
    }
}
